//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
import "../no/Display.js";
let d=[[[0,"Intensity",1,0]],[[["view"],"GetEnabledInView",{R_:{on_or_off:''}},1,0],[["view","on_or_off"],"SetEnabledInView",{},2,0],[["light_type","scene_light_type"],"GetLightType",{},0,0]],[]];
SPLM.Light = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Light";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Light.SceneType = Object.freeze({
    "NotASceneLight" : "NotASceneLight", "Ambient" : "Ambient", "LeftTop" : "LeftTop", "Top" : "Top", "RightTop" : "RightTop", "Front" : "Front", "LeftBottom" : "LeftBottom", "Bottom" : "Bottom", "RightBottom" : "RightBottom"});

export default SPLM;